<template>
  <tr>
    <td class="badge" :class="item.userRole">
      <span class="icoUserRole" :data-role="item.userRole">
        {{item.userRole}}
        <small>({{item.sgusername}})</small>
      </span>
    </td>
    <td class="nickname" :data-user="item.sgusername" :class="{active: focus}" @click="focus = true">
      <input type="text" class="input" v-model="item.sgnickname" @keyup.enter="updateNickname" />
      <button type="button" class="btn btnWhite sizeXs" @click.prevent="updateNickname">{{locale.modify}}</button>
    </td>
    <td class="role">
      <UserRole :value="item.userRole" @changeValue="updateRole" />
    </td>
    <td class="date">
      <span v-if="typeof (item.updateat) !== 'undefined'">
        updated<br>{{date(item.updateat)}}
      </span>
    </td>
  </tr>
</template>

<script>
import moment from 'moment/moment'
import UserRole from '@/components/Admin/UserRole.vue'

export default {
  name: 'UserItem',
  components: {
    UserRole
  },
  props: [
    'locale',
    'item'
  ],
  mounted () {
    document.addEventListener('click', this.active)
  },
  data () {
    return {
      focus: false
    }
  },
  methods: {
    active (e) {
      const nickname = e.target.closest('.nickname')
      this.focus = nickname !== null && nickname.getAttribute('data-user') === this.item.sgusername
    },
    date (date) {
      if (typeof (date) !== 'undefined') {
        return moment(date).format('YYYY-MM-DD HH:mm')
      }
    },
    updateNickname () {
      this.$emit('updateNick', this.item)
    },
    updateRole (role) {
      if (window.confirm(`[${role}] ${this.locale.confirm_modify_role}`)) {
        const userRole = {
          user: this.item.sgusername,
          role: role
        }
        this.$store.dispatch('admin/updateUserRole', userRole).then(() => {
          this.$store.dispatch('admin/getUserList').then(() => {
            alert(this.locale.complete_modify)
            this.focus = false
          })
        })
      }
    }
  }
}
</script>
